import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import OperatingSystem from "../../Components/OperatingSystem";
import MinPlanPrice from "../../Components/MinPlanPrice";
import sal from "sal.js";
import PlanList from "../../Components/PlanList";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function DedicatedServerBrazil() {
    const [applyPaddingClass, setApplyPaddingClass] = useState(false);
    useEffect(() => {
        document.title = "Dedicated Server Brazil with Enterprise-Grade Infrastructure";
          sal();
      }, []);
      const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
    <Helmet>
        <title>Dedicated Server Brazil with Enterprise-Grade Infrastructure</title>
        <meta name="description" content="A powerful Dedicated server Brazil designed for heavy workloads, maximum performance, and secure hosting from a Brazil data center with 24/7 expert support." />
        <meta name="keywords" content="Server Brazil, Dedicated Server , Dedicated Server Brazil" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/dedicated-server-brazil`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/dedicated-server-brazil`} />
        <meta property="og:title" content="Elite Dedicated Server Brazil: Scalable Hosting Solutions" />
        <meta property="og:description" content="Grow your business with the best dedicated server in Brazil. Get superior uptime, solid security, and high speeds that fulfill your evolving business needs." />
    </Helmet>
    <section className="banner banner-security bg-dark control-panel-banner left-to-right-tilt-banner special-tilt-pb">
          <div className="container">
              <div className="row align-items-center">
                  <div className="col-lg-7 col-xl-6">
                      <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          Served. Clean. Fast.
                      </span>
                      <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">    
                      Our Dedicated Server Brazil Just Ate & Left No Crumbs
                      </h1>
                      <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          Are you fed up with lag, high downtime, and receiving unresponsive customer support? It’s not only you-we’ve all been there. But with our Dedicated Server Brazil, things hit differently. Flawless performance and 24/7 support that shows up. 
                      </p>
                      <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                              <span className="btn-arrow__text">
                                  Get Started
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                          </button>
                          <MinPlanPrice category="customizeddbz" />
                      </div>
                      <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                  </div>
                  <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                      <img src="images/our-dedicated-server-brazil.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" />
                  </div>
              </div>
          </div>
      </section>
      <section className="domain-container special-domain-container position-relative z-1 overflow-hidden pb-60">
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-10">
                          <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                              <div className="card-body pt-60 pb-60">
                                  <div className="row justify-content-center">
                                    <div className="col-md-11 col-lg-10 col-xl-10">
                                        <div className="text-center">
                                          <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Slow? Not With Us.</span>
                                            <h4 className="mb-4">
                                                Too Far = Too Slow. It’s the Right Time to Get Closer.
                                            </h4>
                                            <p className="mb-6">
                                              Ughhh… are you dealing with long-distance issues with your server? That’s the reason for the unexpected lag. Choose a specific server location close to you for high speed, seamless vibes, and no wait time.Once it actually hits, you’ll never go back.
                                            </p>
                                            <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    +91-7737300013
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                            <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    Talk to an Expert
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
      </section>
        <section className="pt-60 pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Server That Works According to You.
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Dedicated Server that Actually Understands the Assignment.</h2>
                        <p className="text-dark mb-0 max-text-56 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Even if you are creating big or running clean, dedicated server Brazil always keeps up with your struggle. It’s seamless, stable, and always on point.</p>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">You’re in Charge Now</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/you-re-in-charge.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Umm… always feel restricted by your present host? It’s ok, you don’t feel here. You completely run the show-from the operating system to every single click. Full access, your vibe.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">10 Gbps Speed? It's Giving Jet Fuel</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/10-gbps.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Big applications? Heavy websites? High traffic? Don’t worry, we are there for you. With up to 10 Gbps, all your stuff runs quickly and smoothly, just like butter.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Admin Power = Your Power</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/be-the-admin.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Maybe you just demand everything your way from your present host? It's ok if they won’t, we will say yes to you. Full control means you easily install, delete, and set up how you roll.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">It Just Works with Everything</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/it-just-works-with.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Ranging from SSH to quick file access-no more roadblocks with our dedicated server Brazil. Just all those tools that really play nice with your project workflow.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Ready Before You Blink</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/ready-before-you-blink.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">No more unnecessary waits in the queue. Your server just gets set up in a few hours-not a single day or days. By the time you are ready, so is your hosting.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">All You, No Sharing</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/all-you-no.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">No noisy neighbors who are slowing things down unexpectedly. Get improved speed, a high uptime guarantee, and all the necessary things with our dedicated server Brazil.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
        <section className="price-plan-section pt-100 pb-100 position-relative">
            <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
            <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8">
                            <div className="text-center">
                                <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                                <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> No Limits. All Yours</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <PlanList category={'customizeddbz'}/>
        </section>
        <div className="pt-60 pb-60">
            <div className="pb-60">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <img src="images/server-glitches-not-anymore.webp" alt="image" className="img-fluid full-width-img" />
                        </div>
                        <div className="col-lg-6 ipad-mt">
                            <div className="ps-lg-8 pe-xxl-12">
                                <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    No More Glitches
                                </span>
                                <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    Server Glitches? Not Anymore, Not Ever.
                                </h3>
                                <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                    When setup feels like a puzzle, our experts slide in like the heroes you didn’t know you wanted. Even if it's midnight or mid-lunch hour, our tech professionals are always available on call, on chat, and on MS Teams.
                                    Your struggle deserves no downtime-and we guarantee that.
                                </p>
                                <ul>
                                    <li>Always-on professional support</li>
                                    <li>Real-time talk via call or chat</li>
                                    <li>Constantly monitoring your server</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container pb-60">
        <div className="row">
            <div className="col-12">
                <div className="bg-dark pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-12 col-lg-10 col-xl-5">
                            <h2 className="text-white">
                                Real Ones Don’t Settle For Less
                            </h2>
                            <p className="mb-8 text-white text-opacity-75">
                                Why always stay stuck with the basics when you can boss up? Ranging from high-speed to data control, our hosting is just for you. Tap in and see how your business takes the right flight.
                            </p>
                            <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </button>
                        </div>
                        <div className="col-xl-7 ipad-pro-mt">
                            <div className="row g-4 g-xl-0 feature-card">
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/ready-for-constant.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Ready-to-Go Setups
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Worried about high traffic? Just chill. Our dedicated server Brazil setups manage tasks like a pro, powered by SSDs, DDR4 memory & Intel/AMD tech.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/1-click-&-boom.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            One-Click and You’re In
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Why wait after paying? Start your online hustle in a blink. With only 1 click, get all main CMS platforms like WordPress, Magento, and Drupal on your plan.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/speed-that-actually.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            High Speed, No Lag
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Your business always deserves speed that keeps it running, 24/7. Even if you are scaling or starting, get quick hosting with our dedicated server.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/solid-gear-real.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Solid Gear, Real Results
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Running a serious site or app? You always wish for power that doesn’t quit. Our enterprise-level servers are fine-tuned for high speed and performance.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/ping-us-anytime.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Ping Us Anytime
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Not a big deal, everyone hates waiting. Your dedicated server Brazil is prepared & deployed in no time. Powered by support, your server stays on top.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/control-like.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Full Control, No Issue
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Think about why to play by someone else’s rules. With admin access, our dedicated server hosting gives you the power to twist, modify, and install.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1" />
                </div>
            </div>
        </div>
      </div>
      <OperatingSystem/>
              
        <section className="pt-60 pb-100">
            <div className="container">
                <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                    <div className="row justify-content-center">
                        <div className="col-xxl-7 col-xl-9">
                            <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                    <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                    <small className="text-primary fw-bold">Fast-Loading? Yeah!!! With Us.</small>
                                </div>
                            </div>
                            <div className="text-center mt-5">
                                <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Why Stop Settling for Slow?</h2>
                                <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Sick of that lag life? Dedicated server Brazil is calling you. Get blazing-fast speed, genuine support, and zero tech drama. Get in touch now-your glow-up begins here </p>
                            </div>
                            <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <Link to="#" onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded">
                                    <span className="btn-arrow__text">
                                        Start Now
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                                <Link to="/frequently-asked-questions" className="btn btn-dark btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded">
                                    <span className="btn-arrow__text">
                                        Learn More
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}
